import { useEffect, useState } from 'react'
import { useAuth } from './useAuth'
import * as adminApi from '../lib/api/admin'

export type AdminState = {
  isLoading: boolean
  isAdmin: boolean
  error: string | null
}

export function useIsAdmin(): AdminState {
  const { isLoading: authLoading, isLoggedIn, user, isConfigured } = useAuth()
  const [state, setState] = useState<{ userId: string | null; isAdmin: boolean; error: string | null }>(() => ({
    userId: null,
    isAdmin: false,
    error: null,
  }))

  useEffect(() => {
    if (!isConfigured) return
    if (authLoading) return
    if (!isLoggedIn || !user?.id) return
    if (state.userId === user.id) return

    let mounted = true
    void adminApi
      .isCurrentUserAdmin()
      .then((isAdmin) => {
        if (!mounted) return
        setState({ userId: user.id, isAdmin, error: null })
      })
      .catch((e) => {
        if (!mounted) return
        setState({
          userId: user.id,
          isAdmin: false,
          error: e instanceof Error ? e.message : 'Błąd sprawdzania admina.',
        })
      })

    return () => {
      mounted = false
    }
  }, [authLoading, isLoggedIn, isConfigured, user?.id, state.userId])

  if (!isConfigured) return { isLoading: false, isAdmin: false, error: null }
  if (authLoading) return { isLoading: true, isAdmin: false, error: null }
  if (!isLoggedIn || !user?.id) return { isLoading: false, isAdmin: false, error: null }

  const isCurrent = state.userId === user.id
  return { isLoading: !isCurrent, isAdmin: isCurrent ? state.isAdmin : false, error: isCurrent ? state.error : null }
}

